module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/blank-3e1fbece34610c459a61d2334ea0d8b2.svg";